import { Outlet } from '@rocketlane/rocket-router';

export const NonProtectedRoutesLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
